import React from "react";
import {useBalance} from "../../base/hooks/useBalance";

export function Balance() {
    const { balance, balanceLoading } = useBalance();

    if (balanceLoading) {
        return null;
    }

    return (
        <>
            <span className="text-sm text-gray-500">Balance:</span>
            <span className="ml-1 text-sm font-medium text-gray-900">${Number(balance).toFixed(2)}</span>
        </>
    );
}
